import jwt from 'jsonwebtoken'

export default function decryptToken(token) {
  if (!token) {
    return null;
  }

  const keyword = process.env.REACT_APP_PUBLIC_KEY
  return jwt.decode(token, keyword, { algorithm: 'HS256' });
}
